module.exports = __webpack_public_path__ + "images/a73dad121a312dc2a453cb0d0645e6b7.jpg";